<div class="data-page working-area">
    <div class="row">
        <div class="col-8">
            <kendo-grid [kendoGridBinding]="gridData" [pageSize]="25" [pageable]="true" [sortable]="true" [resizable]="true" [filterable]="true" [selectable]="selectableSettings" (cellClick)="cellClickHandler($event)">
                <kendo-grid-column field="id" title="ID" [width]="50" [filterable]="false"></kendo-grid-column>
                <kendo-grid-column field="title" title="Title"></kendo-grid-column>
                <kendo-grid-column field="type" title="Type" [width]="50"></kendo-grid-column>
                <kendo-grid-column field="category" title="Category" [width]="250"></kendo-grid-column>
                <kendo-grid-column field="unit" title="Unit" [width]="250"></kendo-grid-column>
            </kendo-grid>
        </div>
        <div class="col-4">
            
                <div class="card" id="entityEditForm" *ngIf="!submitted">
                    <div class="card-header">Edit Digital Resource</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col" style="text-align: right;">
                                <mat-checkbox [(ngModel)]="activeResource.isActive" >Active</mat-checkbox>
                            </div>
                        </div>

                        <mat-form-field>
                            <mat-label>Title</mat-label>
                            <textarea matInput rows="2" style="line-height: 2em;" [(ngModel)]="activeResource.title"  required></textarea>
                            <mat-error [hidden]="this.valid">Title is required</mat-error>
                        </mat-form-field>


                        <div class="row">
                            <div class="col-3">
                                <mat-form-field>
                                    <mat-label>OHI Unit</mat-label>
                                    <mat-select [(ngModel)]="activeResource.unitId"  required>
                                        <mat-option *ngFor="let unit of ohiUnits" [value]="unit.id">
                                            {{unit.businessName}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error [hidden]="this.valid">OHI Unit is required</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col-3">
                                <mat-form-field>
                                    <mat-label>Type</mat-label>
                                    <mat-select [(ngModel)]="activeResource.resourceTypeId"  required>
                                        <mat-option *ngFor="let type of resourceTypes" [value]="type.id">
                                            {{type.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error [hidden]="this.valid">Is required</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="col">
                                <mat-form-field>
                                    <mat-label>Category</mat-label>
                                    <mat-select [(ngModel)]="activeResource.categoryId"  required>
                                        <mat-option *ngFor="let category of resourceCategories" [value]="category.id">
                                            {{category.name}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error [hidden]="this.valid">Category is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <mat-form-field>
                            <mat-label *ngIf="activeResource.link; else hint">Link</mat-label>
                            <ng-template #hint>Choose OHI Unit and click button on the right to upload file</ng-template>
                            <mat-progress-bar [value]="file?.progress" *ngIf="uploading"></mat-progress-bar>                              
                            <input matInput [(ngModel)]="activeResource.link"  />
                            <button mat-button class="file-upload" matSuffix mat-icon-button aria-label="Clear" title="Upload document" [disabled]="!activeResource.unitId" (click)="onClick()">                                   
                                    <fa-icon *ngIf="!uploading" [icon]="['fas', 'save']"></fa-icon>     
                                    <fa-icon *ngIf="uploading" [icon]="['fas', 'spinner']" [spin]="true"></fa-icon>                                                                
                            </button>
                        </mat-form-field>

                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" type="reset" (click)="addResource()">
                        <fa-icon [icon]="['fas', 'plus']"></fa-icon>Add New
                    </button>
                        <button class="btn btn-success" (click)="saveResource()" [disabled]="getHasErrors()" [ngClass]="{'error': getHasErrors()}"> 
                       <ng-container *ngIf="saving; then tplSaveing; else tplSaved"></ng-container>
                        <ng-template #tplSaved><fa-icon [icon]="['fas', 'save']"></fa-icon></ng-template> 
                        <ng-template #tplSaveing><fa-icon [icon]="['fas', 'spinner']" [spin]="true" size="lg"></fa-icon></ng-template>                                                                             
                        Save
                    </button>
                    </div>
                    <input type="file" #fileUpload id="fileUpload" name="fileUpload" multiple="multiple" accept="*" style="display:none;" />

                </div>



        </div>
    </div>
</div>